import { SignedIn, UserButton } from "@clerk/clerk-react";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Header() {
  return (
    <header className="bg-[#fafafa] shadow-sm">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <img
              src="/logo.svg"
              alt="aiio dataforge"
              width={120}
              height={24}
              className="h-8 w-auto"
            />
          </div>
          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <SignedIn>
              <UserButton />
            </SignedIn>
          </div>
        </div>
      </div>
    </header>
  );
}
